export const SET_LEAD_GENERATOR_REPORTS = "SET_LEAD_GENERATOR_REPORTS";
export const LOAD_LEAD_GENERATOR_REPORTS_DATA = "LOAD_LEAD_GENERATOR_REPORTS_DATA";
export const SET_LEAD_GENERATOR_REPORTS_DATA = "SET_LEAD_GENERATOR_REPORTS_DATA";
export const LOAD_LEAD_GENERATOR_REPORT_NAME = "LOAD_LEAD_GENERATOR_REPORT_NAME";
export const UPDATE_LEAD_GENERATOR_REPORT_NAME = "UPDATE_LEAD_GENERATOR_REPORT_NAME";
export const ARCHIVE_LEAD_GENERATOR_REPORT = "ARCHIVE_LEAD_GENERATOR_REPORT";
export const UNARCHIVE_LEAD_GENERATOR_REPORT = "UNARCHIVE_LEAD_GENERATOR_REPORT";
